import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { useAPIStore } from "../../Store/APIStore";
import { NotFound } from "../../Views";
import { PuppyProfile } from "./PuppyProfile";
import { EnhancedPuppyProfile } from "./PuppyProfile/EnhancedPuppyProfile";

const PuppyProfileContainer = () => {
  const { profilePath } = useParams();
  const [puppy, setPuppy] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [useEnhancedProfile] = useState(true);
  const { fetchPuppyByPath } = useAPIStore();

  useEffect(() => {
    const fetchPuppyData = async () => {
      try {
        setLoading(true);
        const data = await fetchPuppyByPath(profilePath);
        setPuppy(data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    if (profilePath) {
      fetchPuppyData();
    }
  }, [profilePath]);

  if (loading) {
    return (
      <div className="container my-5">
        <div className="row justify-content-center">
          <div className="col-md-8 text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading puppy profile...</span>
            </div>
            <p className="mt-3">Loading puppy profile...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return <NotFound />;
  }

  if (!puppy) {
    return (
      <div className="container my-5">
        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="alert alert-warning" role="alert">
              <h4 className="alert-heading">Puppy Not Found</h4>
              <p>
                The puppy profile you&apos;re looking for could not be found.
              </p>
              <p className="mb-0">
                Please check the URL or return to the puppy listings.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Render enhanced profile if feature flag is enabled and puppy data is available
  if (useEnhancedProfile && puppy) {
    return <EnhancedPuppyProfile puppy={puppy} />;
  }

  // Fall back to original profile component
  return <PuppyProfile />;
};

export default PuppyProfileContainer;
